import "./App.css";
import React, {useEffect} from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import Layout from "./Layout";
import Home from "./pages/Home/Home";

function App() {
    // useEffect(() => {
    //     const cursor = document.createElement('div');
    //     cursor.classList.add('custom-cursor');
    //     document.body.appendChild(cursor);
    //
    //     const moveCursor = (event) => {
    //         cursor.style.left = `${event.pageX}px`; // 设置横坐标
    //         cursor.style.top = `${event.pageY}px`;  // 设置纵坐标
    //     };
    //
    //     // 侦听鼠标移动事件
    //     document.addEventListener('mousemove', moveCursor);
    //
    //     return () => {
    //         // 清除事件监听器和 DOM 操作
    //         document.removeEventListener('mousemove', moveCursor);
    //         document.body.removeChild(cursor);
    //     };
    // }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Layout/>}>
                    <Route index element={<Home/>}/>
                    <Route path="/" element={<Home/>}/>
                    {/*<Route path="edit_survey" element={<EditSurvey/>}/>*/}
                    {/*<Route path="my_surveys" element={<MySurveys/>}/>*/}
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;